import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const LogoLight = () => (
  <StaticQuery
    query={graphql`
      query {
        logoImage: file(relativePath: { eq: "logo-light.png" }) {
          childImageSharp {
            fixed(width: 170, height: 52) {
              ...GatsbyImageSharpFixed_noBase64
            }
          }
        }
      }
    `}
    render={data => <Img alt="MASS,区块链共识引擎,POC,存储空间租赁,容量证明,共识引擎,挖矿" fixed={data.logoImage.childImageSharp.fixed} />}
  />
)
export default LogoLight
